var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}},[_c('path',{attrs:{"d":"M12 10.725L19.725 3 21 4.275 13.275 12 21 19.725 19.725 21 12 13.275 4.275 21 3 19.725 10.725 12 3 4.275 4.275 3 12 10.725z"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }